import { message, PageHeader, Space } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TableItem, ButtonItem, dineroDisabledMask, ModalItem, FormItem, Form, TextAreaItem, MensajeError } from "../../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import AgregarConciliacion from "./AgregarConciliacion/AgregarConciliacion";
import { extraerLineasDePdf, extraerEncabezadoBanco, guardarPdfPendiente, mensajePdfDeOtroBanco } from "./Conciliacion/extraerDatosBancoPdf";

moment.locale("es");

class Bancos extends Component {
  formRefReabrir = React.createRef();
  pdfInputRef = React.createRef();
  state = {
    todasConciliaciones: [],
    agregarConciliacion: false,
    modalAgregarConciliacion: false,
    loading: false,
    modalReabrirConciliacion: false,
    idAReabrir: null,
    reabriendo: false,
    pdfDesde: null, // { lineas, plantillaId, prefill } al crear desde PDF
    claveSatCuenta: null, 
    bancoSatNombre: null,
  };
  atras() {
    this.props.history.goBack();
  }
  componentDidMount() {
    this.consultarConciliaciones();
    this.consultarBancoCuenta();
  }
  // Banco SAT configurado 
  async consultarBancoCuenta() {
    const bancoId = this.props.location.state.id;
    if (!bancoId) return;
    try {
      const [resBanco, resBancosSat] = await Promise.all([
        axios.post(
          "bancos/datosBanco",
          { empresaId: this.props.empresaId, bancoId },
          { headers: this.props.headersToken }
        ),
        axios.post(
          "bancosSat/selectBancosSat",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        ),
      ]);
      const bancoSatId = resBanco.data?.bancoSatId;
      const catalogo = Array.isArray(resBancosSat.data) ? resBancosSat.data : [];
      const bancoSat = catalogo.find((b) => String(b._id) === String(bancoSatId));
      if (bancoSat) {
        this.setState({
          claveSatCuenta: bancoSat.clave,
          bancoSatNombre: bancoSat.nombreCorto,
        });
      }
    } catch (err) {
      console.error("No se pudo consultar el banco de la cuenta:", err);
    }
  }

  async consultarConciliaciones() {
    this.setState({loading: true})
    await axios
    .post(
      "conciliaciones/selectConciliacionesCuenta",
      { 
        empresaId: this.props.empresaId,
        bancoId: this.props.location.state.id
      },
      {
        headers: this.props.headersToken,
      }
    )
    .then((res) => {
            if (res.data.status === 404) {
            } else {
            this.setState({
                todasConciliaciones: res.data.map(value => {
                    return {...value, accion: { _id: value._id, estado: value.estado }}
                }),
            });
        }
    });
    await axios
    .post(
      "conciliaciones/checarAgregarConciliacion",
      { 
        empresaId: this.props.empresaId,
        bancoId: this.props.location.state.id
      },
      {
        headers: this.props.headersToken,
      }
    )
    .then((res) => {
        if (res.data.success === 2) {
            this.setState({
                agregarConciliacion: true
            });
        }else{
            this.setState({
                agregarConciliacion: false
            });
        }
    });
    this.setState({loading: false})
  }

  abrirReanudarConciliacion(id) {
    this.props.history.push('/panel/conciliacion', {
      id,
      nombre: this.props.location.state.nombre,
      bancoId: this.props.location.state.id,
    })
  }

  abrirAgregarConciliacion() {
    // Alta normal (en blanco): sin pre-llenado de PDF.
    this.setState({ pdfDesde: null, modalAgregarConciliacion: true });
  }

  // "Crear desde PDF": lee el estado de cuenta, extrae período + saldo final y
  // abre el modal pre-llenado. El PDF leído se conserva para cargarlo en la
  // conciliación recién creada.
  async crearDesdePdf(file) {
    if (file.type !== "application/pdf" && !file.name?.endsWith(".pdf")) {
      message.error("El archivo debe ser un PDF");
      return;
    }
    this.setState({ loading: true });
    try {
      const lineas = await extraerLineasDePdf(file);
      const { encabezado, plantilla, conflicto } = extraerEncabezadoBanco(lineas, {
        claveSatCuenta: this.state.claveSatCuenta,
      });
      if (conflicto) {
        this.setState({ loading: false });
        MensajeError(
          mensajePdfDeOtroBanco(conflicto, { bancoSatNombre: this.state.bancoSatNombre })
        );
        return;
      }
      this.setState({
        loading: false,
        modalAgregarConciliacion: true,
        pdfDesde: {
          lineas,
          plantillaId: plantilla.id,
          prefill: {
            fechaInicial: encabezado.fechaInicial || null,
            fechaFinal: encabezado.fechaFinal || null,
            saldoFinal: encabezado.saldoFinal ?? null,
          },
        },
      });
    } catch (err) {
      console.error("Error al leer el PDF:", err);
      message.error("No se pudo leer el PDF");
      this.setState({ loading: false });
    }
  }

  async cerrarAgregarConciliacion(creada) {
    const pdfDesde = this.state.pdfDesde;
    this.setState({ modalAgregarConciliacion: false, pdfDesde: null });
    await this.consultarConciliaciones();

    // Si se creó a partir de un PDF, abrir la conciliación recién creada (la más
    // reciente) con el PDF ya cargado, sin tener que re-subirlo.
    if (creada === true && pdfDesde && pdfDesde.lineas) {
      const nueva = [...this.state.todasConciliaciones].sort(
        (a, b) => moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf()
      )[0];
      if (nueva) {
        guardarPdfPendiente(nueva._id, {
          lineas: pdfDesde.lineas,
          plantillaId: pdfDesde.plantillaId,
        });
        this.props.history.push("/panel/conciliacion", {
          id: nueva._id,
          nombre: this.props.location.state.nombre,
          bancoId: this.props.location.state.id,
        });
      }
    }
  }

  abrirModalReabrir(id) {
    this.setState({ modalReabrirConciliacion: true, idAReabrir: id }, () => {
      if (this.formRefReabrir.current) {
        this.formRefReabrir.current.resetFields();
      }
    });
  }

  cerrarModalReabrir() {
    this.setState({ modalReabrirConciliacion: false, idAReabrir: null });
  }

  async confirmarReabrirConciliacion() {
    try {
      const values = await this.formRefReabrir.current.validateFields();
      this.setState({ reabriendo: true });
      const res = await axios.post(
        "conciliaciones/reabrirConciliacion",
        {
          empresaId: this.props.empresaId,
          conciliacionId: this.state.idAReabrir,
          motivo: values.motivo.trim(),
        },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        message.success("Conciliación reabierta. Los saldos quedan fijos.");
        this.setState({ modalReabrirConciliacion: false, idAReabrir: null });
        this.consultarConciliaciones();
      } else if (res.data.success === 1) {
        message.error(res.data.message || "No se pudo reabrir la conciliación");
      } else {
        message.error("Hubo un error y no se reabrió la conciliación");
      }
    } catch (e) {
      if (e && e.errorFields) return;
      message.error("Hubo un error y no se reabrió la conciliación");
    } finally {
      this.setState({ reabriendo: false });
    }
  }

  render() {
    const columns = [
      {
        title: "Fecha Creación",
        dataIndex: "createdAt",
        key: "createdAt",
        sorter: (a, b) => {
          if (moment(a.createdAt) < moment(b.createdAt)) {
            return -1;
          }
          if (moment(a.createdAt) > moment(b.createdAt)) {
            return 1;
          }
          return 0;
        },
        render: (value) => moment(value).locale("es").format("ll"),
      },
      {
        title: "Referencia",
        dataIndex: "referencia",
        key: "referencia",
      },
      {
        title: "Fecha Inicial",
        dataIndex: "fechaInicial",
        key: "fechaInicial",
        sorter: (a, b) => {
            if (moment(a.createdAt) < moment(b.createdAt)) {
              return -1;
            }
            if (moment(a.createdAt) > moment(b.createdAt)) {
              return 1;
            }
            return 0;
          },
        render: (value) => value ? moment(value).locale("es").format("ll") : 'Sin fecha',
      },
      {
        title: "Fecha Final",
        dataIndex: "fechaFinal",
        key: "fechaFinal",
        sorter: (a, b) => {
            if (moment(a.createdAt) < moment(b.createdAt)) {
              return -1;
            }
            if (moment(a.createdAt) > moment(b.createdAt)) {
              return 1;
            }
            return 0;
          },
        render: (value) => value ? moment(value).locale("es").format("ll") : 'Sin fecha',
      },
      {
        title: "Saldo Inicial",
        dataIndex: "saldoInicial",
        key: "saldoInicial",
        render: (value) => dineroDisabledMask(value)
      },
      {
        title: "Saldo Final",
        dataIndex: "saldoFinal",
        key: "saldoFinal",
        render: (value) => dineroDisabledMask(value)
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        render: (value, record, index) => (
          <Space size="middle" key={index.toString()}>
                {value.estado === 1 && (
                    <ButtonItem key={index.toString()} type='primary' onClick={() => this.abrirReanudarConciliacion(value._id)} size='small'>
                        Reanudar Conciliacion
                    </ButtonItem>
                )}
                {value.estado === 2 && this.props.permisoReabrirConciliacion && (
                    <ButtonItem key={`reabrir-${index}`} blanco onClick={() => this.abrirModalReabrir(value._id)} size='small'>
                        Reabrir
                    </ButtonItem>
                )}
          </Space>
        ),
      },
    ]
    return (
      <>
        <PageHeader
          title={"Conciliaciones: "+this.props.location.state.nombre}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            this.state.agregarConciliacion && (
              <Space>
                <ButtonItem
                  type="primary"
                  key="agregarConciliacion"
                  onClick={this.abrirAgregarConciliacion.bind(this)}
                >
                  Agregar Conciliación
                </ButtonItem>
                <ButtonItem
                  blanco
                  key="crearDesdePdf"
                  icon={<FilePdfOutlined />}
                  onClick={() => this.pdfInputRef.current?.click()}
                >
                  Crear desde PDF
                </ButtonItem>
                <input
                  type="file"
                  ref={this.pdfInputRef}
                  accept=".pdf"
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    e.target.value = "";
                    if (file) this.crearDesdePdf(file);
                  }}
                />
              </Space>
            )
          }
          onBack={this.atras.bind(this)}
        />
        <TableItem           
          onRow={(record, rowIndex) => {
            return {
              onDoubleClick: (event) => {
                if(record.estado === 2){
                  this.props.history.push("/panel/verConciliacion", { id: record._id, bancoId: this.props.location.state.id, nombre: this.props.location.state.nombre });
                }
              },
            };
          }} 
          size='small' loading={this.state.loading} dataSource={this.state.todasConciliaciones} columns={columns} />
        <AgregarConciliacion
              id={this.props.location.state.id}
            visible={this.state.modalAgregarConciliacion}
            prefill={this.state.pdfDesde?.prefill}
            cerrarAgregarConciliacion={this.cerrarAgregarConciliacion.bind(
                this
            )}
        />
        <ModalItem
          title="Reabrir Conciliación"
          visible={this.state.modalReabrirConciliacion}
          onCancel={this.cerrarModalReabrir.bind(this)}
          onOk={this.confirmarReabrirConciliacion.bind(this)}
          spinning={this.state.reabriendo}
          okText="Reabrir"
          footer
          width={500}
          paddingTop
        >
          <p style={{ marginBottom: 10 }}>
            Al reabrir esta conciliación sólo podrás modificar los cargos y abonos marcados. Los saldos inicial y final quedarán fijos.
          </p>
          <Form ref={this.formRefReabrir} name="reabrirConciliacion" layout>
            <FormItem
              label="Motivo"
              name="motivo"
              required
              margin
              rules={[
                { required: true, message: "Captura el motivo de la reapertura" },
                { min: 10, message: "El motivo debe tener al menos 10 caracteres" },
              ]}
            >
              <TextAreaItem placeholder="Motivo de la reapertura" rows={3} />
            </FormItem>
          </Form>
        </ModalItem>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoReabrirConciliacion:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) => valueTodos.permisoId.toString() === "6a03f8699284688444125922"
      )?.activado,
  };
};

export default connect(mapStateToProps)(Bancos);
